/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterPrice_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuPriceRanges_user">;
    readonly " $refType": "SbRespRefineMenuFilterPrice_user";
};
export type SbRespRefineMenuFilterPrice_user$data = SbRespRefineMenuFilterPrice_user;
export type SbRespRefineMenuFilterPrice_user$key = {
    readonly " $data"?: SbRespRefineMenuFilterPrice_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterPrice_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_user",
      "args": null
    }
  ]
};
(node as any).hash = 'd5d1849717150a9b7015e0a209e2f85a';
export default node;
